import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Snackbar,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";

export default function DiscountMasterSwitch({ configId, enabled: enabledProp, onUpdated }) {
  const [enabled, setEnabled] = useState(enabledProp ?? true);
  const [updating, setUpdating] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingValue, setPendingValue] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  useEffect(() => {
    setEnabled(enabledProp ?? true);
  }, [enabledProp]);

  const updateSwitch = (value) => {
    if (!configId) {
      setSnackbar({ open: true, message: "Config not loaded yet", severity: "error" });
      return;
    }

    setUpdating(true);
    axios
      .put("/admin/config-meta", {
        config_id: configId,
        coupon_discount_master_enabled: value,
      })
      .then((res) => {
        if (res.data.status_code === 401) localStorage.clear();
        if (res.data.status) {
          const updated =
            res.data.response?.coupon_discount_master_enabled ?? value;
          setEnabled(updated);
          onUpdated?.();
          setSnackbar({
            open: true,
            message: updated
              ? "Coupon discounts enabled platform-wide"
              : "Coupon discounts disabled platform-wide",
            severity: "success",
          });
        } else {
          setSnackbar({ open: true, message: res.data.message || "Update failed", severity: "error" });
        }
      })
      .catch((err) => {
        setSnackbar({
          open: true,
          message: err.response?.data?.message || "Something went wrong",
          severity: "error",
        });
      })
      .finally(() => {
        setUpdating(false);
        setConfirmOpen(false);
        setPendingValue(null);
      });
  };

  const handleToggle = (e) => {
    const newValue = e.target.checked;
    if (!newValue) {
      setPendingValue(false);
      setConfirmOpen(true);
    } else {
      updateSwitch(true);
    }
  };

  if (!configId) {
    return (
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography color="primary">Coupon Discount Kill Switch :</Typography>
        <Typography variant="h6">Loading...</Typography>
      </Stack>
    );
  }

  return (
    <>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography color="primary">Coupon Discount Kill Switch :</Typography>
          <Typography variant="h6">{enabled ? "Enabled" : "Disabled"}</Typography>
        </Stack>

        <FormControlLabel
          control={
            <Switch
              checked={enabled}
              onChange={handleToggle}
              disabled={updating}
              color={enabled ? "success" : "error"}
            />
          }
          label="Coupon discounts enabled"
        />

        <Alert severity={enabled ? "info" : "warning"} sx={{ maxWidth: 560 }}>
          {enabled
            ? "All publisher coupon discounts are active platform-wide."
            : "All coupon discounts are currently disabled platform-wide."}
        </Alert>
      </Stack>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Disable all coupon discounts?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This will turn off ALL coupon discounts platform-wide immediately. Are you sure?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => updateSwitch(pendingValue)}
            disabled={updating}
          >
            {updating ? "Disabling..." : "Disable All"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
